import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "text-2xl font-bold text-slate-900" }
const _hoisted_7 = { class: "flex flex-wrap gap-6 text-sm text-slate-500" }
const _hoisted_8 = { class: "col-span-12" }
const _hoisted_9 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_10 = { class: "whitespace-pre-wrap leading-7" }
const _hoisted_11 = { class: "col-span-12" }
const _hoisted_12 = { class: "rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "attachment-name" }
const _hoisted_16 = { class: "attachment-actions" }
const _hoisted_17 = {
  key: 1,
  class: "py-4 text-center text-slate-500"
}
const _hoisted_18 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_19 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_20 = { class: "min-w-0 md:col-span-12" }
const _hoisted_21 = { class: "flex shrink-0 flex-wrap gap-2 lg:justify-end" }
const _hoisted_22 = {
  key: 1,
  class: "col-span-12"
}
const _hoisted_23 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_24 = { class: "flex flex-wrap gap-6 text-sm text-slate-500" }
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Chi tiết văn bản" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.documentObject.title), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.documentObject.sender), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-clock mr-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.documentObject.time)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-calendar mr-2" }, null, -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.deadlineClass(_ctx.documentObject.replyDeadline))
                  }, _toDisplayString(_ctx.formatDeadline(_ctx.documentObject.replyDeadline)), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-3 text-lg font-bold text-slate-900" }, " Nội dung ", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.documentObject.content), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "border-b border-slate-200 bg-slate-50 px-3 py-2" }, [
                _createElementVNode("div", { class: "text-sm font-semibold text-slate-700" }, " Tài liệu đính kèm ")
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.documentObject.listAttachments?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentObject.listAttachments, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "attachment-item"
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-file-pdf text-red-500 mr-2" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_Button, {
                              size: "small",
                              icon: "pi pi-eye",
                              label: "Xem",
                              onClick: ($event: any) => (_ctx.viewPdf(item))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_Button, {
                              size: "small",
                              icon: "pi pi-download",
                              label: "Tải",
                              severity: "secondary",
                              onClick: ($event: any) => (_ctx.downloadFile(item))
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, " Không có tài liệu đính kèm "))
              ])
            ])
          ]),
          (!_ctx.documentObject.statusReceiver)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mb-3 text-lg font-bold text-slate-900" }, " Trả lời ", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Nội dung", -1)),
                    _createVNode(_component_Textarea, {
                      id: "content",
                      type: "text",
                      modelValue: _ctx.receiverUpdate.content,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.receiverUpdate.content) = $event)),
                      placeholder: "Nhập nội dung",
                      class: "min-h-[112px]"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Button, {
                      label: "Gởi trả lời",
                      icon: "pi pi-cloud-upload",
                      onClick: _ctx.updateContent,
                      loading: _ctx.loadingBar,
                      disabled: !_ctx.receiverUpdate.content
                    }, null, 8, ["onClick", "loading", "disabled"])
                  ]),
                  _createVNode(_component_Dialog, {
                    header: "Gởi trả lời",
                    visible: _ctx.loadingBar,
                    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loadingBar) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Đang gởi trả lời...", -1)),
                        _createVNode(_component_ProgressBar, { mode: "indeterminate" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.documentObject.contentReceiver), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-clock mr-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.documentObject.timeReceiver)), 1)
                    ])
                  ])
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: _ctx.showPdfDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPdfDialog) = $event)),
      modal: "",
      maximizable: "",
      style: { width: '100vw' },
      breakpoints: { '960px': '100vw' },
      header: _ctx.selectedAttachment?.fileName || 'Xem tài liệu'
    }, {
      default: _withCtx(() => [
        (_ctx.selectedPdf)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: _ctx.selectedPdf,
              width: "100%",
              height: "850",
              frameborder: "0"
            }, null, 8, _hoisted_25))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}